import {
  Input as InputWithValidation,
  TextArea as TextAreaWithValidation,
  RadioGroup as RadioGroupWithValidation,
  Select as SelectWithValidation,
} from '@bingads-webui-react/primitive-validation';

import {
  withSignal,
  CommonEventParser,
} from '@bingads-webui-react/hoc-with-signal';

import type {
  IRadioGroupEventParsed,
  TRadioGroupSelectedItem,
} from './types';

export const Input = withSignal(InputWithValidation, {
  onChange: CommonEventParser,
}) as typeof InputWithValidation;

export const TextArea = withSignal(TextAreaWithValidation, {
  onChange: CommonEventParser,
}) as typeof TextAreaWithValidation;

export const Select = withSignal(SelectWithValidation, {
  onChange: CommonEventParser,
}) as typeof SelectWithValidation;

// RadioGroup onChange param is the selected item
// which could be number, string, or a react element depending on how items were defined
// stringify the selected item disregarding its type in a try/catch block, best effort
const radioGroupEventParser = (e: readonly [TRadioGroupSelectedItem, ...unknown[]]): IRadioGroupEventParsed => {
  let radioGroupSelectedItem;
  try {
    radioGroupSelectedItem = JSON.stringify(e[0]);
  } catch (err) {
    radioGroupSelectedItem = 'Failed to stringify selected item';
  }
  return { radioGroupSelectedItem };
};

export const RadioGroup = withSignal(RadioGroupWithValidation, {
  onChange: radioGroupEventParser,
}) as typeof RadioGroupWithValidation;
